import Spinner from '../icons/Spinner';

const Loading = () => {
    return (
        <div className="w-full inset-0 flex items-center justify-center fixed z-50">
            <Spinner />
        </div>
    );
};

export default Loading;
